import { render, staticRenderFns } from "./weatherForecast2.vue?vue&type=template&id=5a2fdd2d&scoped=true&"
import script from "./weatherForecast2.vue?vue&type=script&lang=js&"
export * from "./weatherForecast2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2fdd2d",
  null
  
)

export default component.exports